import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaFileAlt } from "react-icons/fa";
import { RiArrowRightDoubleFill } from "react-icons/ri";

// import footerBg from '../Assets/Image/footerbgimg.jpeg';



export default function WebFooter() {


  return (
    <>
      <Col lg={12}>
        <div className='p-1 footer-bg'>
          <Container >
            <Row className='mt-3 '>
              <Col lg={4}>
                <h3>XtraGrow Foundation, Inc.</h3>
                <p>
                  XtraGrow Foundation, Inc. collaborates with organizations that share our commitment to sustainable agriculture and community health.

                </p>
                
              </Col>

              <Col lg={4}>
                <h3 >Quick Links</h3>
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                  <li className='mb-2'>
                    <a href="/home" className="footer-link ">
                      <RiArrowRightDoubleFill /> Home
                    </a>
                  </li>
                  <li className='mb-2'>
                    <a href="/aboutus" className="footer-link">
                      <RiArrowRightDoubleFill /> About Us
                    </a>
                  </li>
                  <li className='mb-2'>
                    <a href="/partners" className="footer-link">
                      <RiArrowRightDoubleFill /> Partners
                    </a>
                  </li>
                  <li className='mb-2'>
                    <a href="/contact" className="footer-link">
                      <RiArrowRightDoubleFill /> Contact Us
                    </a>
                  </li>
                </ul>


              </Col>

              <Col lg={4}>
                <h3 >Connect With us</h3>

                <div  >
                  <FaLocationDot /> Texas 75077,USA
                </div>

                {/* <div className='mb-2 '>
                  <a
                    href="https://wa.me/12145360246"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span >
                      <FaMobileAlt />  +1 (214) 536-0246
                    </span>
                  </a>

                </div> */}

                <div className='d-flex '>
                  <a
                    href="david@xtragrowfoundation.org"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span >
                      < MdEmail /> david@xtragrowfoundation.org
                    </span>
                  </a>
                </div>

                <div className='d-flex '>
                  <a
                    href="deborah@xtragrowfoundation.org"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span >
                      < MdEmail /> deborah@xtragrowfoundation.org
                    </span>
                  </a>
                </div>
                <div className='d-flex mt-2 mb-3'>

                  <a className='iconback' href="#">
                    <FaFacebookF />
                  </a>
                  <a className='iconback mx-2' href='#'>
                    <IoLogoYoutube />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaInstagram />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaXTwitter />
                  </a>
                </div>


              </Col>
            </Row>

            <div className=' mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()}  <span className='fw-bold'> XtraGrow Foundation, Inc.</span>  |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
